import React, { Component } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTable from 'Common/ReactTableWrapper';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { OnHandReportListingEnum } from 'Common/FieldEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

class ItemGrid extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    loadingOnHandItems: PropTypes.bool,
    setItemGridInstance: PropTypes.func,
    reactTableRef: PropTypes.object,
  };

  static defaultProps = {
    loadingOnHandItems: false,
    setItemGridInstance: () => {},
    reactTableRef: null,
  };

  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = currentRows.data;
        let filteredData = [];
        let checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[OnHandReportListingEnum.Id]
            ? obj[OnHandReportListingEnum.Id]
            : obj._original[OnHandReportListingEnum.Id];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length > 0 && checkAllIds.length === dataObjs.length
            )}
            onClick={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                this.props.input.value.indexOf(
                  original[OnHandReportListingEnum.Id]
                ) !== -1
              }
              onClick={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: OnHandReportListingEnum.Id,
      ...ReactTableWrapperColumnProperties,
      sortable: false,
      filterable: false,
    },
    {
      Header: () => {
        return (
          <span>
            Item <br />
            Code
          </span>
        );
      },
      visibilityName: 'Item Code',
      accessor: OnHandReportListingEnum.ItemCode,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Description',
      width: 200,
      accessor: OnHandReportListingEnum.Description,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Quantity',
      accessor: OnHandReportListingEnum.Qty,
      className: 'right-align',
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Value On Hand',
      accessor: OnHandReportListingEnum.Value,
      className: 'right-align',
      ...ReactTableWrapperColumnProperties,
    },
  ];

  handleHeaderLevelCheckBox = (data, checked, dataObjs) => {
    const {
      input: { value },
    } = this.props;
    const copySelected = [...value, ...data];
    if (checked) {
      this.props.input.onChange(copySelected);
    } else {
      _.forEach(dataObjs, obj => {
        const id = obj[OnHandReportListingEnum.Id]
          ? obj[OnHandReportListingEnum.Id]
          : obj._original[OnHandReportListingEnum.Id];
        const index = copySelected.indexOf(id);
        if (index !== -1) {
          copySelected.splice(index, 1);
        }
      });
      this.props.input.onChange(copySelected);
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const { input } = this.props;
    const formValues =
      input.value && input.value.length ? [...input.value] : [];
    const index = formValues.indexOf(original[OnHandReportListingEnum.Id]);
    if (checked && index === -1) {
      formValues.push(original[OnHandReportListingEnum.Id]);
    } else if (index > -1) {
      formValues.splice(index, 1);
    }
    input.onChange(formValues);
  };

  render() {
    const {
      loadingOnHandItems,
      dataSource,
      setItemGridInstance,
      reactTableRef,
    } = this.props;

    return (
      <Form.Field>
        <ReactTable
          minRows={0}
          defaultPageSize={20}
          loading={loadingOnHandItems}
          data={dataSource}
          resizable={true}
          className={'-striped -highlight modalGrid'}
          defaultFilterMethod={caseInsensitiveFilter}
          noDataText={loadingOnHandItems ? '' : 'No items found'}
          columns={this.columns}
          menu={false}
          saveState={{
            tableName: TableNamesEnum.ON_HAND_REPORT_ITEM_GRID_TABLE,
          }}
          onRef={setItemGridInstance}
          reactTableRef={reactTableRef}
        />
      </Form.Field>
    );
  }
}

export const ItemGridContainer = ItemGrid;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/onhandreportlisting/ItemGridContainer.js